import script from "./trail-data.vue?vue&type=script&lang=ts&setup=true"
export * from "./trail-data.vue?vue&type=script&lang=ts&setup=true"

import "./trail-data.vue?vue&type=style&index=0&id=02281bde&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02281bde"]])

export default __exports__